import { attr, fk } from 'redux-orm'
import Base from './Base'

class BillingSubscription extends Base {
  static get fields () {
    return {
      id: attr(),
      billableType: attr(),
      billableId: attr(),
      billableName: attr(),
      startsOn: attr(),
      endsOn: attr(),
      status: attr(),
      trialEndsOn: attr(),
      billingEmail: attr(),
      billingVatId: attr(),
      billingAddress: attr(),
      peppolId: attr(),
      deliverViaPeppol: attr(),
      planId: fk('billingPlan', 'subscriptions')
    }
  }
}

BillingSubscription.modelName = 'billingSubscription'

export default BillingSubscription
